/**
 *
 * Module:        Library
 * Name:          Guru Chat History API
 * Description:   Maps existing Firebase chats to the Guru history UI
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

import axios from 'axios';

const apiUrl = path => `${window.QEE_API_URL || ''}/api${path}`;

const historyUserId = () => {
	try {
		const user = JSON.parse(window.sessionStorage.getItem('usr') || '{}');
		return String(user.usrId || '').trim();
	} catch (error) {
		return '';
	}
};

export const listGuruChats = async () => {
	const userId = historyUserId();
	if (!userId) return [];
	const response = await axios.get(apiUrl(`/chat/anonymous/history/${encodeURIComponent(userId)}`));
	const chats = Array.isArray(response.data && response.data.chats) ? response.data.chats : [];
	return chats.sort((left, right) => String(right.updatedAt).localeCompare(String(left.updatedAt)));
};

export const updateGuruChat = async (chatId, changes) => {
	await axios.patch(apiUrl(`/chat/guru/history/${encodeURIComponent(chatId)}`), changes);
};

export const deleteGuruChat = async chatId => {
	await axios.delete(apiUrl(`/chat/guru/history/${encodeURIComponent(chatId)}`));
};
